import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import fontConfig from '../../../Componentes/FontConfig';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import FormEdicaoCliente from './FormEdicaoCliente';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import { SpeedDial } from 'primereact/speeddial';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEditar from '../../../Componentes/BotaoEditar';
import BotaoExcluir from '../../../Componentes/BotaoExcluir';
import SidebarClientes from './SidebarClientes';
import FormNovoCliente from './FormNovoCliente';
import {Icones} from '../../../Componentes/FontConfig'
import SidebarRelatoriosClientes from './SidebarRelatoriosClientes';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';


export default function Clientes(props) {
    const toast = React.useRef(null); // Ref para o Toast
    const [cliente, setCliente]= useState([]);

    const [fieldsFound, setFieldsFound] = useState([]);

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const location = useLocation();

    const { dataEmpresa , fixarCliente, optionReport, disableButtons} = location.state || {};

    const [overlayVisible, setOverlayVisible] = useState(false);

    const op = useRef(null); // Referência para o OverlayPanel

    const overlayBtn = useRef(null); // Referência para o botão de filtro
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const [clientes, setClientes] = useState([]);
    const [clientesFiltrados, setClientesFiltrados] = useState([]);
    const [clienteEdicao, setClienteEdicao] = useState([]);

    const [sideBarOpened, setSideBarOpened] = useState(false);
     
    const resetCliente = () =>{
        setCliente({
            ...cliente, 
            statusCadastro : 'cadastro', 
            idcliente :  -1,
            razaosocial :  "",
            nomefantasia :  "",
            cpf_cnpj :  "",
            rg_insc :  "",
            logradouro :  "",
            numero :  "",
            complemento :  "",
            bairro :  "",
            cep :  "",
            cidade :  "",
            estado :  "",
            telefonecomercial :  "",
            telefonecelular :  "",
            email :  "",
            ativo :  "t",
        })
    }
    const [usuario, setUsuario]= useState([]);
    const [visibleLeft, setVisibleLeft] = useState(false);

    const [verInativos, setVerInativos]= useState(false);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idcliente: { value: dataEmpresa.idcliente !== -1 ? dataEmpresa.idcliente : '', matchMode: FilterMatchMode.CONTAINS },
        razaosocial: { value: '', matchMode: FilterMatchMode.EQUALS },
        nomefantasia: { value: '', matchMode: FilterMatchMode.EQUALS },
        cpf_cnpj: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
        rg_insc: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
        cidade: { value: '', matchMode: FilterMatchMode.EQUALS },
        estado: { value: '', matchMode: FilterMatchMode.EQUALS },
        ativo: { value: 't', matchMode: FilterMatchMode.EQUALS }
    });

   const [isMobile, setIsMobile] = useState(false);

       useEffect(() => {
            console.log(location.state.habilitarinventory )
                   // Função que será chamada quando o tamanho da janela mudar
                   const handleResize = () => {
                    setIsMobile(window.innerWidth < 768);
                   };
           
                   // Adiciona o listener de resize
                   window.addEventListener('resize', handleResize);
           
                   // Limpeza do evento quando o componente for desmontado
                   return () => {
                       window.removeEventListener('resize', handleResize);
                   };
               }, []);


    useEffect(() => {

        setFilters(prevFilters => ({
            ...prevFilters,
            ativo: verInativos === true ? { value: null, matchMode: FilterMatchMode.EQUALS } : { value: 't', matchMode: FilterMatchMode.EQUALS }
        }));

    }, [verInativos]);



   
    const firstGet = useRef(false)
    
    useEffect(() => {
        if(!firstGet.current){
            firstGet.current = true
            getData();
        }

        console.log(location.state)
    }, []);

    useEffect(() => {
        if(!visible){
            setUsuario([])
        }
       

    }, [visible]);

      useEffect(() => {
        setClientesFiltrados(clientes)
       

    }, [clientes]);

    const getData = () => {
        console.log(dataEmpresa)
        clearFilters()

        setLoading(true);

        setTimeout(() => {

            Conexao.post('clientesController/getAllClientes?inativos:sim', { 
               idusuario : dataEmpresa.idrevenda, 
               idempresa : dataEmpresa.idempresa, 
               idcliente : dataEmpresa.idcliente ? dataEmpresa.idcliente : -1, 
               inativos : 'ver-todos', 
               versao : 'v3'
             })
                .then(response => {

                    if (response.status === 200 && response.data.status === 'OK') {

                        setClientes(response.data.payload); 
                        setClientesFiltrados(response.data.payload)
                        setLoading(false);

                    } else {
                        setClientes([])
                        setLoading(false);
                      //  showMessageToast('warn', "Não foi possível recuperar dados")
                    }

                }).catch(error => {
                    setClientes([])
                    setLoading(false);
                    showMessageToast('error', "Não foi possível recuperar dados")
                });

        }, 1000);
    };

  
    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };


  const handleFilterChange = (e, field) => {
    const value = e.target.value;

    setFilters(prevFilters => ({
        ...prevFilters,
        [field]: prevFilters[field] 
            ? { value, matchMode: prevFilters[field].matchMode } 
            : { value, matchMode: FilterMatchMode.CONTAINS } // Define um matchMode padrão
    }));
    };


    const handleFilterConfirm = () => {
        // Aqui você pode aplicar os filtros ao DataTable ou fazer outras ações necessárias
        setOverlayVisible(false); // Fecha o overlay após aplicar os filtros
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value.toLowerCase();
        setGlobalFilterValue(value);
    
        // Atualizar o filtro global corretamente
        setFilters(prevFilters => ({
            ...prevFilters,
            global: { ...prevFilters.global, value }
        }));
    
        // Identificar os campos onde o filtro foi encontrado
        const foundFields = new Set();
        const fields = ['idcliente', 'razaosocial', 'nomefantasia', 'cpf_cnpj', 'rg_insc', 'cidade', 'estado', 'ativo'];
    
        clientes.forEach(cliente => {
            fields.forEach(field => {
                const fieldValue = cliente[field]?.toString().toLowerCase() || ""; // 🔹 Evita erro ao chamar toString()
                if (fieldValue.includes(value)) {
                    foundFields.add(field);
                }
            });
        });
    
        setFieldsFound([...foundFields]); // Converte Set para array
    };
    
   
    
    
    const renderBotaoEditar = (row, opcao) => {
  
        return (
            <Button 
                icon="pi pi-pencil"
                onClick={() => {
                    console.log("Opções para:", row)
                    setCliente(row)
                }} 
                disabled={loading}
                tooltip="Editar dados da empresa" tooltipOptions={{ position: 'left' }}
            />
        );
    };

    const renderBotaoOpcoes= (row, opcao) => {
  
        return (
            <Button 
                disabled={row.ativo === 'f'}
                icon= "pi pi-cog"
                onClick={() => {
                    console.log("Opções para:", row)
                    setClienteEdicao(row)
                    setSideBarOpened(true)
                }} 
    
                tooltip="Acessar opções:Edição, Ativação/Desativação, Acesso Clientes, Exclusão" tooltipOptions={{ position: 'left' }}
            />
        );
    };
    const renderStatusRow= (row, opcao) => {

        return (
            row.ativo =='t' ? <Tag severity="success" value="ATIVO" style={{cursor :'pointer'}} onClick={()=>{
                if(fixarCliente){

                    return
                }
                confirmDialog({
                        message: 'Confirma a INATIVAÇÃO do cliente agora?',
                        header: 'Confirmação',
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: 'Sim',
                        rejectLabel: 'Não',
                        accept: () => {
                              disableRegistro(row)
                        } 
                    });
            }}></Tag> : <Tag severity="danger" value="INATIVO" style={{cursor :'pointer'}}  onClick={()=>{
                confirmDialog({
                        message: 'Confirma a ATIVAÇÃO do cliente agora?',
                        header: 'Confirmação',
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: 'Sim',
                        rejectLabel: 'Não',
                        accept: () => {
                            enableRegistro(row)
                        } 
                    });
            }}></Tag>
        );
    };
    const disableRegistro = (row) =>{
        Conexao.get('clientesController/disableRegistro?idempresa='+row.idempresa+'&idcliente='+row.idcliente)
                .then(response => {

                    if (response.status === 200 && response.data.status === 'OK') {
                         setClientes((prevData) =>
                            prevData.map(cliente =>
                                cliente.idcliente === row.idcliente ? {...cliente, ativo : 'f'} : cliente
                            )
                        );
                        showMessageToast('success', "Registro atualizado com sucesso!")

                    } else {
                      showMessageToast('warn', "Não foi possível atualizar registro")

                    }

                }).catch(error => {
                  showMessageToast('error', "Não foi possível atualizar registro")
                });
    }


    const enableRegistro = (row) =>{
        Conexao.get('clientesController/enableRegistro?idempresa='+row.idempresa+'&idcliente='+row.idcliente)
                .then(response => {

                    if (response.status === 200 && response.data.status === 'OK') {
                         setClientes((prevData) =>
                            prevData.map(cliente =>
                               cliente.idcliente === row.idcliente ? {...cliente, ativo : 't'} : cliente
                            )
                        );
                        showMessageToast('success', "Registro atualizado com sucesso!")

                    } else {
                      showMessageToast('warn', "Não foi possível atualizar registro")

                    }

                }).catch(error => {
                  showMessageToast('error', "Não foi possível atualizar registro")
                });
    }



    const exportarXLSX = async (reportName = 'dados_export_', coluns) => {
        const colunasExportar = ['cpf_cnpj', 'razaosocial', 'nomefantasia', 'cidade', 'estado', 'email']; // Campos que você deseja exportar
        const colunasCabecalho = ['cpfCnpj', 'RazaoSocial', 'nomeFantasia', 'cidade', 'estado', 'email'];

        // Gerar os dados filtrados
        const dadosFiltrados = clientesFiltrados.map(item =>
            colunasExportar.reduce((obj, col) => {
                obj[col] = item[col];
                return obj;
            }, {})
        );

        // Criar worksheet e workbook
        const worksheet = XLSX.utils.json_to_sheet(dadosFiltrados, { header: colunasExportar });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Renomear os cabeçalhos no topo (opcional)
        colunasCabecalho.forEach((label, index) => {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
            worksheet[cellAddress].v = label;
        });

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // Salvar o arquivo
        const { default: saveAs } = await import('file-saver');
        const blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        });
        saveAs(blob, reportName + new Date().getTime() + '.xlsx');
   };



    const exportarParaPDF = () => {
        const doc = new jsPDF({
            orientation: 'landscape', // 👉 paisagem
            unit: 'pt',
            format: 'a4'
        });

        // Cabeçalhos personalizados
        const colunas = [
            { header: 'CPF/CNPJ', dataKey: 'cpf_cnpj' },
            { header: 'Razão Social', dataKey: 'razaosocial' },
            { header: 'Nome Fantasia', dataKey: 'nomefantasia' },
            { header: 'Cidade', dataKey: 'cidade' },
            { header: 'Estado', dataKey: 'estado' },
            { header: 'Email', dataKey: 'email' },
        ];

        const dataAtual = new Date().toLocaleString('pt-BR');

    // Título
        doc.setFontSize(14);
        doc.text('Relatório de Clientes', 40, 40);
        doc.setFontSize(10);
        doc.text(`Data de emissão: ${dataAtual}`, 40, 55);
      
        // Título opcional
        doc.text('Relatório de Clientes', 14, 15);

        autoTable(doc, {
            headStyles: { fillColor: [26, 35, 126] },
            theme: 'striped',
            columns: colunas,
            body: clientesFiltrados, 
            margin: { top: 60, left: 40, right: 40 },
            startY: 70,
        });

        doc.save('clientes_' + new Date().getTime() + '.pdf');
    };
    

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '30px', paddingLeft : '0px'}}>
               
                <div className="flex align-items-center gap-2">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search" />
                        <InputText 
                            value={globalFilterValue} 
                            onChange={onGlobalFilterChange} 
                            placeholder="Pesquisa global" 
                            tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                        />
                    </IconField>
                    <Button 
                        icon="pi pi-filter-slash" 
                        className="p-button-secondary p-button-sm" 
                        onClick={clearFilters} 
                        tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                    />
                    
                    <Button 
                        icon="pi pi-sync" 
                        className= "p-button-secondary p-button-sm" 
                        onClick={getData} 
                        tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                    />        
                    {!fixarCliente && !disableButtons ? <FormNovoCliente 
                            disabled ={fixarCliente}
                            Conexao={Conexao}
                            visible={visible} 
                            setLoading ={setLoading}
                            dataEmpresa = {dataEmpresa}
                            showMessage ={showMessage}
                            setClientes = {(data)=>{
                                
                                setClientes(prevClientes => [...prevClientes, data]);
                                
                            }}
                            setVisible={(op)=>setVisible(op)} 
                    /> : null }
                    {optionReport === 'contadores' ? 
                    <SidebarRelatoriosClientes 
                        dataEmpresa = {dataEmpresa}
                        showMessage = {showMessageToast}
                        fixarCliente ={fixarCliente || clientesFiltrados.length === 1}             
                        clientes ={fixarCliente || clientesFiltrados.length === 1 ? clientesFiltrados[0] : clientesFiltrados}
                    />  : null }  
                     
                </div>
                <div className="flex flex-column align-items-start mb-3">
                    
                    <span className="text-small">Inativos</span>
                    <InputSwitch checked={verInativos} disabled={fixarCliente || disableButtons}
                        onChange={() => {
                            setVerInativos(!verInativos)
                        }
                            
                        }/>
                </div>
            </div>
        );
    };
    

    const renderFooter = () => {
        if (fieldsFound.length === 0 && 1 !== 1) {
            return  <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {clientes.length} 
        </div>
        }
        
        return <>
        <div className='flex flex-wrap'>
            <div className='col-12 md:col-10'>
                <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
                    Total de registros: {clientes.length} 
                </div>
                <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
                    Filtro encontrado em: {fieldsFound.join(', ')}
                </div>
            </div>
            <div className='col-12 md:col-2'>
                
                <Button icon="pi pi-file" className='ml-1'  onClick={exportarCSV} tooltip='Baixar dados em CSV' severity="secondary" />  
                <Button icon="pi pi-file-excel" className='ml-1'  onClick={exportarXLSX}  tooltip='Baixar dados em EXCEL' severity='waning'/> 
                <Button icon="pi pi-file-pdf" className='ml-1'  onClick={exportarParaPDF}  tooltip='Baixar dados em PDF' severity="danger" />  
                 
            </div>
            
        </div>
        
    </>
    };

    const clearFilters = () => {
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            idcliente: { value: dataEmpresa.idcliente !== -1 ? dataEmpresa.idcliente : '', matchMode: FilterMatchMode.CONTAINS },
            razaosocial: { value: '', matchMode: FilterMatchMode.EQUALS },
            nomefantasia: { value: '', matchMode: FilterMatchMode.EQUALS },
            cpf_cnpj: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
            rg_insc: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
            cidade: { value: '', matchMode: FilterMatchMode.EQUALS },
            estado: { value: '', matchMode: FilterMatchMode.EQUALS },
            ativo: { value: 't', matchMode: FilterMatchMode.EQUALS }
        });
        setFieldsFound([]); // Resetando os campos encontrados
    };



    useEffect(()=>{

    }, [fieldsFound])
    

    const toastBottomCenter = useRef(null);
    
    
    const showMessage = (severity, title, text) => {
        const label = title;

        toastBottomCenter.current.show({ severity: severity, title: label, detail: text, life: 3000 });
    };

    const deleteClienteRevenda = (idempresa, idcliente) =>{
        setLoading(true)
        Conexao.post('clientesController/deleteClienteRevenda', {
            idempresa : idempresa, 
            idcliente : idcliente
        }).then(response =>{
            if (response.status === 200 && response.data.status === 'OK') {

                setClientes(clientes.filter(item => item.idcliente !== idcliente));

                setLoading(false);
                showMessageToast('success', 'Registro excluido com sucesso!')
            } else {
                setClientes([])
                setLoading(false);
                  showMessageToast('warn', "Não foi possível excluir registro")
            }
        }).catch(error =>{
            
            showMessageToast('error', "Não foi possível excluir registro")
        })
    }
    const dt = useRef(null);

    const exportarCSV = () => {

        
        dt.current.exportCSV();
    };



    return (
        <Layout loading={loading} >
            <div className="p-2">
                
                <Toast ref={toastBottomCenter} position="top-right" />
                <div className="border-round-lg surface-card shadow-0 p-2">
                    {/* Botão para abrir o OverlayPanel */}
                    
                        {
                            disableButtons ? <DataTable
                            header={renderHeader()}  
                            footer={renderFooter} 
                            value={clientes}
                            ref={dt}
                            paginator                 
                            rows={10} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '35rem', fontSize : '11px' }}
                            onValueChange={(valoresVisiveis) => {
                                setClientesFiltrados(valoresVisiveis)
                                }}
                            bodyStyle={{fontSize : '10px'}}                            
                            filters={filters} // Aplicando os filtros
                            filterDisplay="menu"// Exibe os filtros como menu pop-up
             
                        >
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.tableBody, width : '5%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="idcliente" 
                                header="Código" 
                                name="idcliente" 
                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar Código" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '12%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="cpf_cnpj" 
                                header="CNPJ/CPF" 
                                name="cpf_cnpj" 
                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pelo CNPJ/CPF" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '34%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="razaosocial" 
                                name="razaosocial" 
                                header="Razão Social/Nome" 

                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pela razão social" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '20%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="cidade" 
                                header="Cidade" 
                                name="cidade" 
                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pela Cidade" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '40%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="estado" 
                                header="Estado" 
                                name="estado" 
                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pelo Estado" />
                       
                                
                        </DataTable>
                        :
                        <DataTable
                            header={renderHeader()}  
                            footer={renderFooter} 
                            value={clientes}
                            ref={dt}
                            paginator                 
                            rows={10} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '35rem', fontSize : '11px' }}
                            onValueChange={(valoresVisiveis) => {
                                setClientesFiltrados(valoresVisiveis)
                                }}
                            bodyStyle={{fontSize : '10px'}}                            
                            filters={filters} // Aplicando os filtros
                            filterDisplay="menu"// Exibe os filtros como menu pop-up
             
                        >
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.tableBody, width : '5%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="idcliente" 
                                header="Código" 
                                name="idcliente" 
                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                 filterElement={(options) => (
                                    <InputText
                                        value={options.value}                                        
                                        onChange={(e) => options.filterCallback(e.target.value)}
                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                        placeholder=""
                                        />
                                )}
                                filterPlaceholder="Filtrar Código" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '12%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="cpf_cnpj" 
                                header="CNPJ/CPF" 
                                name="cpf_cnpj" 
                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                 filterElement={(options) => (
                                    <InputText
                                        value={options.value}                                        
                                        onChange={(e) => options.filterCallback(e.target.value)}
                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                        placeholder=""
                                        />
                                )}
                                filterPlaceholder="Filtrar pelo CNPJ/CPF" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '34%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="razaosocial" 
                                name="razaosocial" 
                                header="Razão Social/Nome" 

                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter
                                 filterElement={(options) => (
                                    <InputText
                                        value={options.value}                                        
                                        onChange={(e) => options.filterCallback(e.target.value)}
                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                        placeholder=""
                                        />
                                )} 
                                filterPlaceholder="Filtrar pela razão social" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '20%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="cidade" 
                                header="Cidade" 
                                name="cidade" 
                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                 filterElement={(options) => (
                                    <InputText
                                        value={options.value}                                        
                                        onChange={(e) => options.filterCallback(e.target.value)}
                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                        placeholder=""
                                        />
                                )}
                                filterPlaceholder="Filtrar pela Cidade" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '40%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="estado" 
                                header="Estado" 
                                name="estado" 
                                body={loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterElement={(options) => (
                                    <InputText
                                        value={options.value}                                        
                                        onChange={(e) => options.filterCallback(e.target.value)}
                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                        placeholder=""
                                        />
                                )}
                                filterPlaceholder="Filtrar pelo Estado" />
                       
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '40%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="ativo" 
                                sortable
                                header="Status" 
                                body={(row)=>loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : renderStatusRow(row)}/>
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '40%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                header="Editar" 
                                body={(row)=>loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : 
                                <FormEdicaoCliente 
                                    disabled={row.ativo === 'f' || fixarCliente}
                                    {...props} 
                                    Conexao={Conexao}   
                                    setCliente={setCliente} 
                                    dataEmpresa ={dataEmpresa}
                                    updateClientes={(data) => {
                                       setClientes((prevData) =>
                                        prevData.map(cliente =>
                                            cliente.idcliente === data.idcliente ? data : cliente
                                        )
                                        );

                                    }}
                                    showMessage={showMessage}
                                    cliente={row} 
                                    Icones={Icones}
                                    />

                                }/>
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '40%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                header="Delete" 
                                body={(row)=>loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : 
                                     <Button 
                                        icon= "pi pi-ban"
                                        severity="danger" 
                                        disabled={fixarCliente}
                                        onClick={() => {
                                            if(dataEmpresa.bloqueiofinanceiro === 't') {
                           
                                                showMessageToast("error", 'Este recurso esta Bloqueado! Entre em contato com a Databit');
                                                return;
                                            }  
                                            confirmDialog({
                                                    message: 'Deseja realmente excluir este CLIENTE? Esta ação não tem como ser revertida!',
                                                    header: 'Confirmação',
                                                    icon: 'pi pi-exclamation-triangle',
                                                    acceptLabel: 'Sim',
                                                    rejectLabel: 'Não',
                                                    accept: () => {
                                                        deleteClienteRevenda(row.idempresa, row.idcliente)
                                                    } 
                                                });
                                        
                                        }} 
                                        
                                        
                                        tooltip="Excluir o cliente selecionado! Esta ação não pode ser desfeita!" tooltipOptions={{ position: 'left' }}
                                />}/>
                           <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '40%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                header="Opções" 
                                body={(row)=>loading && !sideBarOpened ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : renderBotaoOpcoes(row)}/>
                                                  
                        </DataTable>
}
                </div>

               
            </div>
            <OverlayPanel ref={op} style={{ width: '300px' }}>
                                <div className="p-3">
                                    <h4>Filtros</h4>
                                    <div className="p-field">
                                        <label htmlFor="idempresa">Código</label>
                                        <InputText
                                            id="idcliente"
                                            value={filters.idcliente.value}
                                            onChange={(e) => handleFilterChange(e, 'idcliente')}
                                        />
                                    </div>
                                    <div className="p-field">
                                        <label htmlFor="razaosocial">Razão Social</label>
                                        <InputText
                                            id="razaosocial"
                                            value={filters.razaosocial.value}
                                            onChange={(e) => handleFilterChange(e, 'razaosocial')}
                                        />
                                    </div>
                                    <div className="p-field">
                                        <label htmlFor="cidade">Cidade</label>
                                        <InputText
                                            id="cidade"
                                            value={filters.cidade.value}
                                            onChange={(e) => handleFilterChange(e, 'cidade')}
                                        />
                                    </div>
                                    <div className="p-field">
                                        <label htmlFor="estado">UF</label>
                                        <InputText
                                            id="estado"
                                            value={filters.estado.value}
                                            onChange={(e) => handleFilterChange(e, 'estado')}
                                        />
                                    </div>
                                    <Button label="Aplicar Filtro" icon="pi pi-check" onClick={handleFilterConfirm} />
                                </div>
                            </OverlayPanel>
             <Toast ref={toast} />
             <SidebarClientes 
                cliente = {clienteEdicao} 
                isMobile={isMobile}
                Conexao={Conexao}
                fixarCliente ={fixarCliente}
                setLoading ={setLoading}
                setSideBarOpened = {setSideBarOpened}
                dataEmpresa = {dataEmpresa}
                showMessage ={showMessage}
                setClientes = {(data)=>{                    
                    setClientes(prevClientes => [...prevClientes, data]);                    
                }}
                updateClientes = {(data)=>{
                    
                    setClientes(prevClientes => data);
                    
                }}
                setCliente={(val)=>{
                    setClienteEdicao(val)
                    
                    }}/>
             
        </Layout>
    );
}
